import React,{ Component } from "react";
import { connect } from "react-redux";
import { get_saml_configs, deleteSaml, set_saml_config, update_saml_config,setSamlPageInfo } from "../../actions/actionSaml";
import { Row, Col, InputGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Saml",path:"/saml",isActive: true},
    {name: "Update Saml",path:"/updatesaml",isActive: true},
];


class Saml extends Component{
    constructor(props) {
        super(props);
        
        this.state = {
            modal: false,
            samlId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.createSaml = this.createSaml.bind(this);
        this.deleteSamlAction = this.deleteSamlAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleAddSuccess = this.handleAddSuccess.bind(this);
        this.handleAddError = this.handleAddError.bind(this);
        this.addConfig = this.addConfig.bind(this);
    }

    componentDidMount() {
        this.props.getConfigs();
    }

    addConfig(){
        let formData = {};
        formData.display_name = " ";
        this.props.set_saml(formData)
            .then(() => {
                this.createSaml();
            })
            .catch(() => {
                this.handleAddError()
            });
    }

    createSaml(){
        const {SamlErrorMessage, saml_set} = this.props;
        let formData = {};
        if(SamlErrorMessage) {
            NotificationManager.error(SamlErrorMessage,"Failed to Add Saml Configuration", 3000);
        }else {
            formData.saml_id = saml_set.saml_id;
            formData.sp_acs_url = "https://" + window.location.host + "/api/acs/?id=" + saml_set.saml_id;
            formData.sp_slo_url = "https://" + window.location.host + "/api/slo/?id=" + saml_set.saml_id;
            formData.sp_entity_id = "https://" + window.location.host + "/api/metadata/?id=" + saml_set.saml_id;
            this.props.update_saml(formData)
                .then(() => {
                    this.handleAddSuccess();
                })
                .catch(() => {
                    this.handleAddError()
                });
        }
    }

    handleAddSuccess(){
        const {SamlErrorMessage, saml_set} = this.props;
        if(SamlErrorMessage) {
            NotificationManager.error(SamlErrorMessage,"Failed to Add Saml Configuration", 3000);
        }else{
            NotificationManager.success("Saml Added Successfully","Add Saml", 3000);
            this.setState({addModal: false});
            window.location.href = "/#/updatesaml/" + saml_set.saml_id;
        }
    }

    handleAddError(){
        const {SamlError} = this.props;
        if(SamlError){
            NotificationManager.error(SamlError,"Failed to Add Saml Configuration", 3000);
            this.props.history.push("/saml");
        }else{
            NotificationManager.error("Failed to Add Saml","Add Saml", 3000);
            this.props.history.push("/saml");
        }
    }

    deleteConfirm(samlId){
        this.setState({modal: !this.state.modal,
            samlId: samlId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteSamlAction(){
        this.props.deleteSaml(this.state.samlId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteSamlErrorMessage} = this.props;
        if(deleteSamlErrorMessage) {
            NotificationManager.error(deleteSamlErrorMessage,"Failed to Delete Saml", 3000);
        }else{
            NotificationManager.success("Saml Deleted Successfully","Delete Saml", 3000);
            this.setState({modal: false});
            this.props.getConfigs();
        }
    }

    handleDeleteError(){
        const {deleteSamlError} = this.props;
        if(deleteSamlError){
            NotificationManager.error(deleteSamlError,"Failed to Delete Saml", 3000);
            this.props.history.push("/saml");
        }else{
            NotificationManager.error("Failed to Delete Saml","Delete Saml", 3000);
            this.props.history.push("/saml");
        }
    }

    render(){
        if (this.props.samlConfigLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { saml_configs } = this.props;
        
        const tableColumns = [
            {
                type: "text",
                name: "Display Name",
                accessor: "display_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Enabled",
                accessor: "enabled",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Auto Login",
                accessor: "auto_login",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "edit":
                    this.props.history.push(`/updatesaml/${item.saml_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.saml_id);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-book"></i> <strong>Saml Configurations</strong></div>
                                    <button
                                        className="pull-right adduser-btn"
                                        onClick={this.addConfig}
                                        size="sm"
                                        color="dark">
                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add Configuration
                                    </button>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="saml"
                                    data={saml_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                        className="cancel-button"
                        color="basic">Close</Button>
                        <Button onClick={this.deleteSamlAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Saml.propTypes = {

};


export default connect(state =>
        ({
            saml_configs: state.saml.saml_configs || [],
            deleteSamlErrorMessage: state.saml.deleteSamlErrorMessage || null,
            deleteSamlLoading: state.saml.deleteSamlLoading || false,
            deleteSamlError: state.saml.deleteSamlError || null,
            SamlErrorMessage: state.saml.SamlErrorMessage || null,
            saml_set: state.saml.saml_set || null,
            SamlError: state.saml.SamlError || null,
            samlConfigLoading: state.saml.samlConfigLoading || null,
            pages : {pageSize : state.saml.pageSize, pageNo : state.saml.pageNo},
        }),
    dispatch =>
        ({
            getConfigs: () => dispatch(get_saml_configs()),
            deleteSaml: (data) => dispatch(deleteSaml(data)),
            set_saml: (formData) => dispatch(set_saml_config(formData)),
            update_saml: (formData) => dispatch(update_saml_config(formData)),
            setPageInfo : (data)=> dispatch(setSamlPageInfo(data)),
        }))(Saml);


// WEBPACK FOOTER //
// ./src/views/Saml/Saml.js